import { render, staticRenderFns } from "./summaryrequest.vue?vue&type=template&id=4f16b063&scoped=true&"
import script from "./summaryrequest.vue?vue&type=script&lang=js&"
export * from "./summaryrequest.vue?vue&type=script&lang=js&"
import style0 from "./summaryrequest.vue?vue&type=style&index=0&id=4f16b063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f16b063",
  null
  
)

export default component.exports